<val-boite-dialogue-generique #boiteDialogue
                              [titre]="'achat.selection-statut.titre' | transloco"
                              class="val-selection-statut-facture-achat-edition"
															[validerDesactive]="statutSelectionne === null || (!motifDesactive && motifSelectionne === null) || (motifSelectionne && motifSelectionne.noteObligatoire && donnees.note.trim () === '')"
															(validerClick)="Valider ()"
															(annulerClick)="Annuler ()">
	<div contenu class="val-selection-statut-facture-achat-edition-contenu">
		<val-simple-panel>
			<val-controle-conteneur [label]="'achat.selection-statut.statut' | transloco"
			                        [tailleLabel]="tailleLabels">
				<kendo-combobox class="val-kd-combobox"
				                size="small"
												[clearButton]="false"
												[popupSettings]="{appendTo: 'component', popupClass: 'val-kd-combo-popup'}"
												[data]="statuts"
												textField="codeLibelle"
												valueField="identifiant"
												[(value)]="statutSelectionne"
												(selectionChange)="SelectionStatutChange($event)">
				</kendo-combobox>
			</val-controle-conteneur>
			<div style="height: 4px;"></div>
			<val-controle-conteneur [label]="'achat.selection-statut.motif' | transloco"
			                        [tailleLabel]="tailleLabels">
				<kendo-combobox class="val-kd-combobox"
				                size="small"
												[clearButton]="false"
												[popupSettings]="{appendTo: 'component', popupClass: 'val-kd-combo-popup'}"
												[data]="statutSelectionne?.motifs"
												textField="codeLibelle"
												valueField="identifiant"
												[(value)]="motifSelectionne"
												[disabled]="motifDesactive">
				</kendo-combobox>
			</val-controle-conteneur>
			<div style="height: 4px;"></div>
			<val-controle-conteneur [label]="'achat.selection-statut.note' | transloco"
			                        [tailleLabel]="tailleLabels">
				<kendo-textarea class="val-kd-texte-editeur val-editeur-note"
				                [rows]="5"
												[maxlength]="500"
				                resizable="none"
												[(value)]="donnees.note">
				</kendo-textarea>
			</val-controle-conteneur>
		</val-simple-panel>
	</div>
</val-boite-dialogue-generique>
